<script>
import { CdrImg, CdrButton, IconMinusFill } from '@rei/cedar';
import StoreStatusComponent from '../commons/open-until/StoreStatusComponent.vue';

export default {
  name: 'DoMoreInStoreCardComponent',
  components: {
    StoreStatusComponent,
    CdrImg,
    CdrButton,
    IconMinusFill,
  },
  props: {
    indexCard: { type: Number, required: true },
    doMoreInStoreCard: {
      type: Object,
      required: true,
    },
  },
  computed: {
    storeRestrictionTitle() {
      if (this.doMoreInStoreCard.temporarilyClosed) {
        return 'Temporarily Closed';
      }
      if (this.doMoreInStoreCard.seasonallyClosed) {
        return 'Seasonally Closed';
      }
      return '';
    },
  },
};
</script>

<template>
  <article
    v-if="doMoreInStoreCard.enabled"
    :id="doMoreInStoreCard.id"
    class="do-more-in-store-service"
  >
    <div>
      <cdr-img
        v-if="doMoreInStoreCard.imageModel.enabled"
        :alt="doMoreInStoreCard.imageModel.imageAlt"
        :src="doMoreInStoreCard.imageModel.imageSrc"
        class="do-more-in-store-service__image"
        modifier="responsive"
      />
    </div>
    <div class="do-more-in-store-service__content">
      <h3
        class="do-more-in-store-service__content-title"
      >
        {{ doMoreInStoreCard.title }}
      </h3>
      <div class="do-more-in-store-service__status">
        <store-status-component
          v-if="doMoreInStoreCard.temporarilyClosed || doMoreInStoreCard.seasonallyClosed"
          :title="storeRestrictionTitle"
          :icon-text="'Unavailable'"
          data-ui="open-until"
        >
          <icon-minus-fill class="store-status__icon store-status__icon--red" />
        </store-status-component>
      </div>
      <div
        class="do-more-in-store-service__content-text"
        v-html="doMoreInStoreCard.text"
      />
      <div v-if="doMoreInStoreCard.linkHippoModel.enabled">
        <cdr-button
          tag="a"
          :href="doMoreInStoreCard.linkHippoModel.target"
          modifier="secondary"
          :data-ui="`${doMoreInStoreCard.title}-button`"
        >
          {{ doMoreInStoreCard.linkHippoModel.text }}
        </cdr-button>
      </div>
    </div>
  </article>
</template>
<style lang="scss">
@import "@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss";
.do-more-in-store {
  margin-top: $cdr-space-two-x;
  &__title {
    @include cdr-text-heading-serif-500;
  }
}

.do-more-in-store-service {
  &__content {
    margin: $cdr-space-one-x 0 $cdr-space-two-x;
  }
  &__content-title {
    @include cdr-text-subheading-sans-400;
  }
  &__content-text {
    margin: $cdr-space-one-x 0;
  }
  &:last-child {
    margin: 0;
  }
  &__status {
    margin-bottom: $cdr-space-one-x;
  }
  &__image {
    display: block;
  }
}

/**
* Tablet implementation with CEDAR Breakpoints
 */
@media screen and (min-width: $cdr-breakpoint-sm) {
  .do-more-in-store {
    &__title {
      @include cdr-text-heading-serif-600;
    }
  }
  .do-more-in-store-service {
    display: grid;
    grid-template-columns: 5fr 7fr;
    column-gap: $cdr-space-one-x;
    margin: 0 0 $cdr-space-two-x;
    &__content {
      margin: 0;
    }
  }
}

/**
* Desktop implementation with CEDAR Breakpoints
 */
@media screen and (min-width: $cdr-breakpoint-md) {
  .do-more-in-store {
    margin-top: $cdr-space-four-x;
    &__title {
      margin-bottom: $cdr-space-two-x;
      @include cdr-text-heading-serif-700;
    }
  }
  .do-more-in-store-service {
    &__content-title {
      @include cdr-text-subheading-sans-500;
    }
  }
}
</style>